module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/analyticsInterceptor/analyticsInterceptor.ts
var getCookie = function getCookie(name) {
  var regexp = new RegExp("(?:^" + name + "|; *" + name + ")=(.*?)(?:;|$)", 'g');
  var result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
};

var getBcId = function getBcId() {
  return getCookie('BrowserCookieId');
};

var makeAnalyticsInterceptor = function makeAnalyticsInterceptor(_ref) {
  var allowedUrls = _ref.allowedUrls,
      appVersion = _ref.appVersion;
  return function (request) {
    var _getCookie, _window$WURFL;

    if (allowedUrls.some(function (url) {
      var _request$url;

      return !((_request$url = request.url) !== null && _request$url !== void 0 && _request$url.includes(url));
    })) {
      return request;
    }

    var platform = (_getCookie = getCookie('X-CVNA-DeviceType')) != null ? _getCookie : 'Web';
    var appVersionHeader = platform === 'Web' ? appVersion : getCookie('X-CVNA-AppVersion');
    var bcid = getBcId();
    /* eslint-disable-next-line camelcase */

    var deviceType = platform === 'Web' ? (_window$WURFL = window.WURFL) === null || _window$WURFL === void 0 ? void 0 : _window$WURFL.form_factor : platform;
    request.headers['X-CVNA-Platform'] = platform;
    request.headers['X-CVNA-AppVersion'] = appVersionHeader;
    request.headers['X-CVNA-DeviceType'] = deviceType;

    if (platform === 'Web') {
      request.headers['X-CVNA-BrowserCookieId'] = bcid;
    } else {
      request.headers['X-CVNA-DeviceId'] = getCookie('X-CVNA-DeviceId');
    }

    return request;
  };
};

/* harmony default export */ var analyticsInterceptor = (makeAnalyticsInterceptor);
// CONCATENATED MODULE: ./src/detectMobile/detectMobile.ts
var hasMobileUserAgent = function hasMobileUserAgent(navigator) {
  if (navigator === void 0) {
    navigator = window.navigator || {
      userAgent: ''
    };
  }

  return /CarvanaNativeWebView/gi.test(navigator.userAgent);
};

var iPhoneRegex = new RegExp('CarvanaNativeWebView/(?<AppVersion>\\S+) \\((?<DeviceName>[^;]+); CPU iPhone OS (?<OsVersion>\\S+)');
var androidRegex = new RegExp('CarvanaNativeWebView/(?<AppVersion>\\S+) \\(Linux; Android (?<OsVersion>[^;]+); (?<DeviceName>[^;]+); wv');

var mobileVersion = function mobileVersion(_temp) {
  var _matches$groups, _matches$groups2, _matches$groups3;

  var _ref = _temp === void 0 ? window.navigator || {
    userAgent: ''
  } : _temp,
      userAgent = _ref.userAgent;

  if (!/CarvanaNativeWebView/gi.test(userAgent)) {
    return null;
  }

  var iPhone = /iPhone/.test(userAgent);
  var regex = iPhone ? iPhoneRegex : androidRegex;
  var matches = regex.exec(userAgent);
  return {
    appVersion: (matches === null || matches === void 0 ? void 0 : (_matches$groups = matches.groups) === null || _matches$groups === void 0 ? void 0 : _matches$groups.AppVersion) || 'Unknown',
    osVersion: (matches === null || matches === void 0 ? void 0 : (_matches$groups2 = matches.groups) === null || _matches$groups2 === void 0 ? void 0 : _matches$groups2.OsVersion) || 'Unknown',
    deviceName: (matches === null || matches === void 0 ? void 0 : (_matches$groups3 = matches.groups) === null || _matches$groups3 === void 0 ? void 0 : _matches$groups3.DeviceName) || 'Unknown',
    appType: iPhone ? 'iPhone' : 'Android',
    matched: matches != null,
    userAgent: userAgent
  };
};


// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport hasMobileUserAgent */__webpack_require__.d(__webpack_exports__, "hasMobileUserAgent", function() { return hasMobileUserAgent; });
/* concated harmony reexport makeAnalyticsInterceptor */__webpack_require__.d(__webpack_exports__, "makeAnalyticsInterceptor", function() { return analyticsInterceptor; });
/* concated harmony reexport mobileVersion */__webpack_require__.d(__webpack_exports__, "mobileVersion", function() { return mobileVersion; });




/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.ts");


/***/ })

/******/ });
//# sourceMappingURL=index.js.map